import type { Asset } from '~/common/models/asset.model';
import type { AssetReportItem } from '~/common/models/asset-report.model';
import { ConnectivityStatusType } from '~/common/models/common.model';

export const MOCK_ASSET_LIST: Array<Asset> = [
  {
    id: '00000000000000000',
    name: '00000000000000000',
    licensePlate: 'KL1234',
    connectivityBoardingStatus: ConnectivityStatusType.CONNECTED,
    tcpsAccepted: true,
    type: {
      model: 'test',
      version: 'test',
    },
    vehicleType: {
      make: 'Chevrolet',
      model: 'Camaro',
      year: '2001',
    },
  },
  {
    id: '1GYKPMRKXPZ000023',
    name: '000023 - 2023 Lyriq EV',
    licensePlate: '1234',
    connectivityBoardingStatus: ConnectivityStatusType.CONNECTED,
    tcpsAccepted: true,
    type: {
      model: 'test',
      version: 'test',
    },
    vehicleType: {
      make: 'Cadillac',
      model: 'Lyriq EV',
      year: '2023',
    },
  },
  {
    id: '000334434343434343',
    name: '000334434343434343',
    licensePlate: '123123zxc',
    connectivityBoardingStatus: ConnectivityStatusType.CONNECTED,
    tcpsAccepted: true,
    type: {
      model: 'test',
      version: 'test',
    },
    vehicleType: {
      make: 'GM',
      model: 'GMC',
      year: '2023',
    },
  },
  {
    id: '0202211122334146602022',
    name: '0202211122334146602022',
    licensePlate: 'RFA4321',
    connectivityBoardingStatus: ConnectivityStatusType.CONNECTED,
    tcpsAccepted: true,
    type: {
      model: 'test',
      version: 'test',
    },
    vehicleType: {
      make: 'Cadillac',
      model: 'Escalade',
      year: '2023',
    },
  },
  {
    id: '1GKS2EKL9PR100096',
    name: '100096 - 2023 Denali',
    licensePlate: 'ABCD1234',
    connectivityBoardingStatus: ConnectivityStatusType.CONNECTED,
    tcpsAccepted: true,
    type: {
      model: 'test',
      version: 'test',
    },
    vehicleType: {
      make: 'GMC',
      model: 'Denali',
      year: '2023',
    },
  },
  {
    id: '3GTUUFEL2PG140746',
    name: '140746 - 2023 Sierra',
    licensePlate: 'SIE4321',
    connectivityBoardingStatus: ConnectivityStatusType.CONNECTED,
    tcpsAccepted: true,
    type: {
      model: 'test',
      version: 'test',
    },
    vehicleType: {
      make: 'GMC',
      model: 'Sierra',
      year: '2023',
    },
  },
  {
    id: '1GNSCTKL4PR100012',
    name: '100012 - 2023 Tahoe',
    licensePlate: 'TAH6241',
    connectivityBoardingStatus: ConnectivityStatusType.CONNECTED,
    tcpsAccepted: true,
    type: {
      model: 'test',
      version: 'test',
    },
    vehicleType: {
      make: 'Chevrolet',
      model: 'Tahoe',
      year: '2023',
    },
  },
];

export const MOCK_ASSET_REPORT_ITEM_LIST: AssetReportItem[] = [
  {
    id: '1GNSCTKL4PR100012',
    name: '100012 - Test',
    licensePlate: '1409FP1',
    type: {
      model: 'model',
      version: '1',
    },
    vehicleType: {
      make: 'Chevrolet',
      model: 'Tahoe',
      year: '2023',
    },
    imageUrl: '09545',
  },
  {
    id: '1GNSCTKL4PR100013',
    name: '100012 - Test',
    licensePlate: '1409FP1',
    type: {
      model: 'model',
      version: '1',
    },
    vehicleType: {
      make: 'GMC',
      model: 'Sierra',
      year: '2023',
    },
    imageUrl: '09545',
    driver: {
      firstName: 'John',
      lastName: 'Ron',
      email: 'johnRon@mail.com',
    },
  },
];
